import { FeatureDTO } from "./FeatureDTO";

export class EditCustomerEmailFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
